import { Chip } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniChip = withUnistyles(Chip)

export default UniChip
